import React from 'react';
import {
  EditOutlined,
  TeamOutlined,
  DatabaseOutlined,
  ApartmentOutlined,
  DashboardOutlined,
  UserOutlined,
  SettingOutlined,
  BookOutlined,
  KeyOutlined,
  BarChartOutlined,
  CommentOutlined,
  ExperimentOutlined,
  MessageOutlined,
  GoldOutlined,
  ProfileOutlined,
  FileSearchOutlined,
  AreaChartOutlined,
  ProjectOutlined,
  CustomerServiceOutlined,
  DownloadOutlined
} from '@ant-design/icons';

import { RESOURCE_CODE } from 'libs/contants';

import {
  algorithmCenterModelDetail,
  feedback,
  feedbackDetail,
  questionCenterDetail,
  questionCenter,
  unit,
  group,
  groupDetail,
  testPaper,
  projectManage,
  projectManageEdit,
  situationManage,
  evaluatePracticeProjectAbility,
  studyGroupManage,
  scenesManage,
  quickConfiguration,
  examConfiguration,
  questionGroupManage,
  questionGroupConfig,
  questionConfigUnderGroup,
  tplManage,
  practiceDataManage,
  examRecordManage,
  contentManagement,
  anchor,
  noAuthConfig,
  organizationConfig,
  dashboardMemberConfig,
  groupAndUnitComment,
  projectDashboard,
  projectCustomForAZ,
  abilityModalReportConfig,
  cheatconfig,
  examGroupConfig,
  notificationManage,
  aiQuestion,
  aiQuestionBank,
  aiQuestionEdit,
  authority
} from './routeConfig';

import withPermissions from 'components/withPermissions';

const routes: IRoute[] = [];
const getRoutes = (config: any) => {
  return [
    {
      path: '/',
      component: React.lazy(() => import('layouts/BlankLayout')),
      routes: [
        {
          path: '/admin',
          component: React.lazy(() => import('layouts/BlankLayout')),
          routes: [
            {
              path: '/admin/login',
              component: React.lazy(() => import('pages/admin/loginV2'))
            }
          ]
        },
        {
          path: '/transfer',
          component: React.lazy(() => import('pages/admin/transfer'))
        },
        {
          path: '/',
          component: React.lazy(() => import('layouts/BasicLayout')),
          routes: [
            {
              path: '/v2_dashboard',
              name: '数据仪表盘',
              component: withPermissions(RESOURCE_CODE.DASHBOARD_V2)(
                React.lazy(() => import('pages/dashboard2'))
              ),
              icon: <DashboardOutlined />,
              code: RESOURCE_CODE.DASHBOARD_V2,
              exact: true
            },
            {
              path: dashboardMemberConfig.memberDetail,
              name: '个人能力报告',
              component: withPermissions(RESOURCE_CODE.DASHBOARD_V2)(
                React.lazy(() => import('pages/dashboardProjectMember'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              path: dashboardMemberConfig.memberPracticeDetail,
              name: '场景列表',
              component: withPermissions(RESOURCE_CODE.DASHBOARD_V2)(
                React.lazy(() => import('pages/dashboardProjectMember/memberStandardGroups'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              // 蒂升定制题组列表
              path: dashboardMemberConfig.customMemberSituationDetail,
              name: '题组列表',
              component: withPermissions(RESOURCE_CODE.DASHBOARD_V2)(
                React.lazy(() => import('pages/dashboardProjectMember/memberStandardPractices'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              // 标准题组列表
              path: dashboardMemberConfig.memberSituationDetail,
              name: '题组列表',
              component: withPermissions(RESOURCE_CODE.DASHBOARD_V2)(
                React.lazy(() => import('pages/dashboardProjectMember/memberStandardPractices'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              path: '/dashboard',
              name: 'dashboard',
              component: withPermissions(RESOURCE_CODE.DASHBOARD)(
                React.lazy(() => import('pages/dashboard'))
              ),
              icon: <DashboardOutlined />,
              code: RESOURCE_CODE.DASHBOARD
            },
            {
              path: '/stafflist',
              name: '员工管理',
              component: withPermissions(RESOURCE_CODE.STAFF_MANAGE)(
                React.lazy(() => import('pages/stafflist'))
              ),
              icon: <TeamOutlined />,
              code: RESOURCE_CODE.STAFF_MANAGE
            },
            {
              path: '/recordlist',
              name: '评估记录',
              component: withPermissions(RESOURCE_CODE.PRACTICE_RECORD)(
                React.lazy(() => import('pages/recordlist'))
              ),
              icon: <EditOutlined />,
              code: RESOURCE_CODE.PRACTICE_RECORD,
              routes: [
                {
                  path: '/recordlist/student',
                  name: '学员',
                  component: React.lazy(() => import('pages/recordlist/student')),
                  exact: true
                },
                {
                  path: '/recordlist/student/report/:unitPracticeId',
                  name: '报告详情',
                  component: React.lazy(() => import('pages/recordlist/Record/Detail')),
                  exact: true
                },
                {
                  path: '/recordlist/teacher',
                  name: '老师',
                  code: RESOURCE_CODE.TEACHER_PRACTICE_RECORD,
                  component: withPermissions(RESOURCE_CODE.TEACHER_PRACTICE_RECORD)(
                    React.lazy(() => import('pages/recordlist/teacher'))
                  ),
                  exact: true
                },
                {
                  path: '/recordlist/teacher/report/:unitPracticeId',
                  name: '报告详情',
                  component: React.lazy(() => import('pages/recordlist/Record/Detail')),
                  exact: true
                },
                {
                  path: '/recordlist/record/:unitId/:staffId',
                  component: React.lazy(() => import('pages/recordlist/Record/StaffRecord')),
                  showInMenu: false
                },
                {
                  path: '/recordlist/detail/:unitId/:staffId/:unitPracticeId',
                  component: React.lazy(() => import('pages/recordlist/Record/Detail')),
                  showInMenu: false
                },
                //  高级查询
                {
                  path: '/recordlist/advancedSearch',
                  component: React.lazy(() => import('pages/recordlist/AdvancedSearch')),
                  showInMenu: false
                }
                // {
                //     path: '/recordlist',
                //     redirect: '/recordlist/student',
                //     showInMenu: false
                // }
              ]
            },
            {
              name: '案例管理',
              icon: <ApartmentOutlined />,
              code: RESOURCE_CODE.CASE_MANAGEMENT,
              component: withPermissions(RESOURCE_CODE.CASE_MANAGEMENT)(
                React.lazy(() => import('pages/caseManagement'))
              ),
              path: '/case_management',
              routes: [
                {
                  path: '/case_management/cases',
                  name: '优秀案例',
                  component: React.lazy(() => import('pages/caseManagement/case'))
                },
                {
                  path: '/case_management/students',
                  name: '优秀学员',
                  component: React.lazy(() => import('pages/caseManagement/student'))
                }
              ]
            },
            {
              name: '优秀案例管理',
              icon: <ApartmentOutlined />,
              code: RESOURCE_CODE.EXCELLENT_CASE,
              component: React.lazy(() => import('pages/caseManagement2/case')),
              path: '/caseManagement2',
              exact: true
            },
            {
              name: `${config?.practiceDisplayName}详情`,
              path: '/caseManagement2/:id',
              exact: true,
              showInMenu: false,
              component: withPermissions(RESOURCE_CODE.ROUND_PRACTICE_RECORD)(
                React.lazy(() => import('pages/practiceData/detail'))
              )
            },
            {
              name: '模板管理',
              icon: <ProfileOutlined />,
              code: RESOURCE_CODE.TPL_MANAGE,
              component: withPermissions(RESOURCE_CODE.TPL_MANAGE)(
                React.lazy(() => import('pages/tplManagement/tplList'))
              ),
              path: tplManage.listPath,
              exact: true
            },
            {
              name: '模板新建',
              component: withPermissions(RESOURCE_CODE.TPL_MANAGE)(
                React.lazy(() => import('pages/tplManagement/tplEdit'))
              ),
              path: tplManage.createPath,
              showInMenu: false,
              exact: true
            },
            {
              name: '模板编辑',
              component: withPermissions(RESOURCE_CODE.TPL_MANAGE)(
                React.lazy(() => import('pages/tplManagement/tplEdit'))
              ),
              path: tplManage.editPath,
              showInMenu: false,
              exact: true
            },
            {
              name: `${config?.identityDisplayName}管理`,
              path: projectManage.path,
              code: RESOURCE_CODE.PRODUCT_MANAGE,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/projectManagement'))
              ),
              icon: <DatabaseOutlined />,
              exact: true
            },
            {
              name: `${config?.identityDisplayName}编辑`,
              path: projectManageEdit.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE_UPDATE)(
                React.lazy(() => import('pages/projectManagement/projectManagementEdit'))
              ),
              code: RESOURCE_CODE.PRODUCT_MANAGE_UPDATE,
              icon: <DatabaseOutlined />,
              exact: true
            },
            {
              name: '通知推送管理',
              path: notificationManage.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE_PUSH_RULE)(
                React.lazy(() => import('pages/notificationManagement'))
              ),
              exact: true
            },
            {
              name: '新建推送',
              path: notificationManage.create,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE_PUSH_RULE)(
                React.lazy(() => import('pages/notificationManagement/Edit'))
              ),
              exact: true
            },
            {
              name: '编辑推送',
              path: notificationManage.update,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE_PUSH_RULE)(
                React.lazy(() => import('pages/notificationManagement/Edit'))
              ),
              exact: true
            },
            {
              name: '推送记录',
              path: notificationManage.record,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE_PUSH_RULE)(
                React.lazy(() => import('pages/notificationManagement/record'))
              ),
              exact: true
            },
            {
              name: '数据看板',
              path: projectDashboard.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE_DATA_BOARD)(
                React.lazy(() => import('pages/projectDashboard'))
              ),
              icon: <DatabaseOutlined />,
              exact: true
            },
            {
              name: '定制看板',
              path: projectCustomForAZ.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE_CUSTOM_DASHBOARD)(
                React.lazy(() => import('pages/projectCustomForAZ'))
              ),
              icon: <DatabaseOutlined />,
              exact: true
            },
            {
              name: '定制看板案例',
              path: projectCustomForAZ.case,
              // todo 权限code
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE_DATA_BOARD)(
                React.lazy(() => import('pages/projectCustomForAZ/case'))
              ),
              icon: <DatabaseOutlined />,
              exact: true
            },
            {
              name: '能力评价管理',
              path: evaluatePracticeProjectAbility.path,
              component: React.lazy(() => import('pages/evaluatePracticeProjectAbility')),
              exact: true,
              isNeedConfirmBeforeLeave: true,
              beforeLeaveConfirmConfig: {
                title: '操作提示',
                content: '即将离开当前配置项，请确认当前配置已保存',
                confirmText: '直接离开',
                cancelText: '继续编辑'
              }
            },
            {
              name: '学习小组配置',
              path: studyGroupManage.path,
              component: React.lazy(() => import('pages/studyGroupManage')),
              exact: true
            },
            {
              name: `${config?.groupDisplayName}管理`,
              path: situationManage.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/situationManagement'))
              ),
              exact: true
            },
            {
              name: '评语配置',
              path: groupAndUnitComment.path,
              component: React.lazy(() => import('pages/groupAndUnitComment')),
              exact: true
            },
            {
              name: `${config?.unitDisplayName}管理`,
              path: scenesManage.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/scenesManagement'))
              ),
              exact: true
            },
            {
              name: '题组管理',
              path: questionGroupManage.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/questionGroupManagement'))
              ),
              exact: true
            },
            {
              name: '新建题组',
              path: questionGroupConfig.create,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/groupAndQuestionConfig'))
              ),
              exact: true
            },
            {
              name: '题组配置',
              path: questionGroupConfig.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/groupAndQuestionConfig'))
              ),
              exact: true
            },
            {
              name: `异常监控配置`,
              path: cheatconfig.practicePath,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/situationManagement/cheatConfig'))
              ),
              exact: true
            },
            {
              name: '题目闯关',
              path: questionGroupConfig.graphPath,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/questionGraph'))
              ),
              exact: true
            },
            {
              name: '新建题目',
              path: questionConfigUnderGroup.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/questionConfig'))
              ),
              exact: true
            } /*  */,
            {
              name: '编辑题目',
              path: questionConfigUnderGroup.update,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/questionConfig'))
              ),
              exact: true,
              showInMenu: false
            },
            {
              name: '快速配卷',
              path: quickConfiguration.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/quickConfiguration'))
              ),
              exact: true
            },
            {
              name: '编辑',
              path: quickConfiguration.update,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/quickConfiguration'))
              ),
              exact: true
            },
            {
              name: `${config?.examDisplayName}卷管理`,
              path: examConfiguration.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/exam'))
              ),
              exact: true
            },
            {
              name: `异常监控配置`,
              path: cheatconfig.examPath,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/situationManagement/cheatConfig'))
              ),
              exact: true
            },
            {
              name: `闯关配置`,
              path: examGroupConfig.path,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/situationManagement/examGroupConfig'))
              ),
              exact: true
            },
            {
              name: `${config?.examDisplayName}卷配置`,
              path: examConfiguration.config,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/groupAndQuestionConfig'))
              ),
              exact: true
            },
            {
              name: `${config?.examDisplayName}卷`,
              path: examConfiguration.examPaperList,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/examPaper/list'))
              ),
              exact: true
            },
            {
              name: `${config?.examDisplayName}卷详情`,
              path: examConfiguration.examPaperDetail,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/examPaper/detail'))
              ),
              exact: true
            },
            // 从考试中进入的编辑题目
            {
              name: '编辑题目',
              path: examConfiguration.updateQuestion,
              component: withPermissions(RESOURCE_CODE.PRODUCT_MANAGE)(
                React.lazy(() => import('pages/questionConfig'))
              ),
              exact: true,
              showInMenu: false
            },
            {
              name: `${config?.practiceDisplayName}记录`,
              icon: <FileSearchOutlined />,
              path: practiceDataManage.listPath,
              code: RESOURCE_CODE.ROUND_PRACTICE_RECORD,
              exact: true,
              component: withPermissions(RESOURCE_CODE.ROUND_PRACTICE_RECORD)(
                React.lazy(() => import('pages/practiceData/list'))
              )
            },
            {
              name: `${config?.examDisplayName}记录`,
              icon: <AreaChartOutlined />,
              path: examRecordManage.listPath,
              code: RESOURCE_CODE.EXAM_RECORD,
              exact: true,
              component: withPermissions(RESOURCE_CODE.EXAM_RECORD)(
                React.lazy(() => import('pages/examRecord/list'))
              )
            },
            {
              path: '/report/exchangelist',
              name: '交流记录',
              component: withPermissions(RESOURCE_CODE.COMMUNITY_TOPIC)(
                React.lazy(() => import('pages/exchangeRecord/list'))
              ),
              exact: true,
              icon: <CommentOutlined />,
              code: RESOURCE_CODE.COMMUNITY_TOPIC
            },
            {
              path: '/download-center',
              name: '下载中心',
              icon: <DownloadOutlined />,
              code: RESOURCE_CODE.DOWNLOAD_CENTER,
              component: withPermissions(RESOURCE_CODE.DOWNLOAD_CENTER)(
                React.lazy(() => import('pages/downloadCenter'))
              )
            },
            {
              name: '学习中心',
              icon: <ApartmentOutlined />,
              code: RESOURCE_CODE.LEARN_CENTER,
              component: withPermissions(RESOURCE_CODE.LEARN_CENTER)(
                React.lazy(() => import('pages/contentManagement'))
              ),
              path: '/learn',
              routes: [
                {
                  name: '内容管理',
                  path: contentManagement.path,
                  exact: true,
                  component: withPermissions(RESOURCE_CODE.LEARN_CENTER)(
                    React.lazy(() => import('pages/contentManagement/content'))
                  )
                },
                {
                  name: '学习旅程管理',
                  path: contentManagement.journeyPath,
                  exact: true,
                  component: withPermissions(RESOURCE_CODE.LEARN_CENTER)(
                    React.lazy(() => import('pages/contentManagement/studyJourney'))
                  )
                },
                {
                  name: '新增内容',
                  path: contentManagement.contentCreate,
                  exact: true,
                  showInMenu: false,
                  component: withPermissions(RESOURCE_CODE.LEARN_CENTER)(
                    React.lazy(() => import('pages/contentManagement/studyContentEditor'))
                  )
                },

                {
                  name: '编辑内容',
                  path: contentManagement.contentUpdate,
                  exact: true,
                  showInMenu: false,
                  component: withPermissions(RESOURCE_CODE.LEARN_CENTER)(
                    React.lazy(() => import('pages/contentManagement/studyContentEditor'))
                  )
                },
                {
                  name: '复制内容',
                  path: contentManagement.contentCopy,
                  exact: true,
                  showInMenu: false,
                  component: withPermissions(RESOURCE_CODE.LEARN_CENTER)(
                    React.lazy(() => import('pages/contentManagement/studyContentEditor'))
                  )
                },
                {
                  name: '新建学习旅程',
                  path: contentManagement.studyJourneyCreate,
                  exact: true,
                  showInMenu: false,
                  component: withPermissions(RESOURCE_CODE.LEARN_CENTER)(
                    React.lazy(() => import('pages/contentManagement/studyJourneyEditor'))
                  )
                },
                {
                  name: '编辑学习旅程',
                  path: contentManagement.studyJourneyUpdate,
                  exact: true,
                  showInMenu: false,
                  component: withPermissions(RESOURCE_CODE.LEARN_CENTER)(
                    React.lazy(() => import('pages/contentManagement/studyJourneyEditor'))
                  )
                }
              ]
            },

            {
              path: '/report/exchange-report/:id',
              name: '交流记录详情',
              exact: true,
              showInMenu: false,
              component: withPermissions(RESOURCE_CODE.COMMUNITY_TOPIC)(
                React.lazy(() => import('pages/exchangeRecord/detail'))
              )
            },
            {
              name: `${config?.examDisplayName}详情`,
              path: examRecordManage.detailPath,
              exact: true,
              component: withPermissions(RESOURCE_CODE.EXAM_RECORD)(
                React.lazy(() => import('pages/examRecord/detail'))
              )
            },
            {
              name: `${config?.practiceDisplayName}详情`,
              path: practiceDataManage.detailPath,
              exact: true,
              showInMenu: false,
              component: withPermissions(RESOURCE_CODE.ROUND_PRACTICE_RECORD)(
                React.lazy(() => import('pages/practiceData/detail'))
              )
            },
            {
              path: feedback.path,
              component: withPermissions(RESOURCE_CODE.FEEDBACK)(
                React.lazy(() => import('pages/feedback'))
              ),
              name: '反馈管理',
              icon: <MessageOutlined />,
              code: RESOURCE_CODE.FEEDBACK,
              exact: true
            },
            {
              path: feedbackDetail.path,
              showInMenu: false,
              exact: true,
              name: '反馈详情',
              component: withPermissions(RESOURCE_CODE.FEEDBACK)(
                React.lazy(() => import('pages/feedback/detail'))
              )
            },
            {
              name: 'splitter',
              splitter: true
            },
            {
              name: '组织架构配置',
              icon: <ApartmentOutlined />,
              code: RESOURCE_CODE.ORG_SETTING,
              component: withPermissions(RESOURCE_CODE.ORG_SETTING)(
                React.lazy(() => import('pages/organization'))
              ),
              path: organizationConfig.path,
              routes: [
                {
                  path: organizationConfig.studentPath,
                  name: '学员管理',
                  component: withPermissions(RESOURCE_CODE.ORG_STUDENT)(
                    React.lazy(() => import('pages/organization/student'))
                  ),
                  code: RESOURCE_CODE.ORG_STUDENT,
                  exact: true
                },
                {
                  path: organizationConfig.teacherPath,
                  name: '老师管理',
                  component: withPermissions(RESOURCE_CODE.ORG_TEACHER)(
                    React.lazy(() => import('pages/organization/teacher'))
                  ),
                  code: RESOURCE_CODE.ORG_TEACHER,
                  exact: true
                },
                {
                  path: organizationConfig.recycleBin,
                  name: '回收站',
                  component: React.lazy(() => import('pages/organization/recycleBin')),
                  showInMenu: false,
                  exact: true
                }
              ]
            },
            {
              path: '/authority',
              name: '权限管理',
              icon: <KeyOutlined />,
              code: RESOURCE_CODE.AUTHORITY,
              component: withPermissions(RESOURCE_CODE.AUTHORITY)(
                React.lazy(() => import('pages/authority'))
              ),
              routes: [
                {
                  path: authority.role,
                  name: '角色管理',
                  component: withPermissions(RESOURCE_CODE.AUTHORITY)(
                    React.lazy(() => import('pages/authority/role'))
                  )
                },
                {
                  path: authority.account,
                  name: '账号管理',
                  component: withPermissions(RESOURCE_CODE.AUTHORITY)(
                    React.lazy(() => import('pages/authority/user'))
                  )
                },
                {
                  path: authority.createRole,
                  name: '新建角色',
                  showInMenu: false,
                  exact: true,
                  component: withPermissions(RESOURCE_CODE.AUTHORITY)(
                    React.lazy(() => import('pages/authority/roleDetail'))
                  )
                },
                {
                  path: authority.updateRole,
                  name: '编辑角色',
                  component: withPermissions(RESOURCE_CODE.AUTHORITY)(
                    React.lazy(() => import('pages/authority/roleDetail'))
                  ),
                  showInMenu: false
                }
              ]
            },
            {
              path: '/identity',
              name: '专题管理',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/identityManagement'))
              ),
              code: RESOURCE_CODE.IDENTITY_MANAGEMENT,
              icon: <DatabaseOutlined />,
              exact: true
            },
            {
              path: group.path,
              name: '陪练组管理',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/group'))
              ),
              code: RESOURCE_CODE.PRACTICE_GROUP,
              showInMenu: false,
              exact: true
            },
            {
              path: groupDetail.path,
              name: '陪练单元管理',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/group/unit'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              path: questionCenter.path,
              name: '题目中心',
              exact: true,
              component: withPermissions(RESOURCE_CODE.QUESTION_CENTER)(
                React.lazy(() => import('pages/questionCenter'))
              ),
              icon: <GoldOutlined />,
              code: RESOURCE_CODE.QUESTION_CENTER
            },
            {
              path: anchor.path,
              name: 'Anchor库管理',
              exact: true,
              code: RESOURCE_CODE.ANCHOR_MANAGEMENT,
              component: withPermissions(RESOURCE_CODE.ANCHOR_MANAGEMENT)(
                React.lazy(() => import('pages/anchor'))
              ),
              icon: <ProjectOutlined />
            },
            {
              path: '/algorithmCenter',
              component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                React.lazy(() => import('pages/authority'))
              ),
              name: '算法中心',
              icon: <ExperimentOutlined />,
              code: RESOURCE_CODE.ALGORITHM_CENTER,
              routes: [
                // {
                //   path: '/algorithmCenter/algorithm-manage-list',
                //   name: '算法配置',
                //   exact: true,
                //   component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                //     React.lazy(() => import('pages/algorithmManageList'))
                //   )
                // },
                {
                  path: '/algorithmCenter/list',
                  name: '算法模型',
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm'))
                  ),
                  exact: true
                },
                {
                  path: '/algorithmCenter/model',
                  name: '算法接口',
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithmModel'))
                  )
                },
                {
                  path: algorithmCenterModelDetail.content.add,
                  showInMenu: false,
                  exact: true,
                  name: '新建内容能力模型',
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/contentDetail'))
                  )
                },
                {
                  name: '编辑内容能力模型',
                  path: algorithmCenterModelDetail.content.edit,
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/contentDetail'))
                  ),
                  showInMenu: false
                },
                {
                  name: '复制内容能力模型',
                  path: algorithmCenterModelDetail.content.copy,
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/contentDetail'))
                  ),
                  showInMenu: false
                },
                {
                  path: algorithmCenterModelDetail.expression.add,
                  showInMenu: false,
                  exact: true,
                  name: '新建表达能力模型',
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/expressionDetail'))
                  )
                },
                {
                  name: '编辑表达能力模型',
                  path: algorithmCenterModelDetail.expression.edit,
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/expressionDetail'))
                  ),
                  showInMenu: false
                },
                {
                  name: '复制表达能力模型',
                  path: algorithmCenterModelDetail.expression.copy,
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/expressionDetail'))
                  ),
                  showInMenu: false
                },
                {
                  path: algorithmCenterModelDetail.customize.add,
                  showInMenu: false,
                  exact: true,
                  name: '新建组合模型',
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/customizeDetail'))
                  )
                },
                {
                  name: '编辑组合模型',
                  path: algorithmCenterModelDetail.customize.edit,
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/customizeDetail'))
                  ),
                  showInMenu: false
                },
                {
                  name: '复制组合模型',
                  path: algorithmCenterModelDetail.customize.copy,
                  component: withPermissions(RESOURCE_CODE.ALGORITHM_CENTER)(
                    React.lazy(() => import('pages/algorithm/customizeDetail'))
                  ),
                  showInMenu: false
                }
              ]
            },
            {
              name: '新建题目',
              path: questionCenterDetail.create,
              exact: true,
              component: withPermissions(RESOURCE_CODE.QUESTION_CENTER)(
                React.lazy(() => import('pages/questionCenter/detail'))
              ),
              showInMenu: false
            },
            {
              name: '编辑题目',
              path: questionCenterDetail.update,
              exact: true,
              component: withPermissions(RESOURCE_CODE.QUESTION_CENTER)(
                React.lazy(() => import('pages/questionCenter/detail'))
              ),
              showInMenu: false
            },
            {
              name: '复制题目',
              path: questionCenterDetail.copy,
              exact: true,
              component: withPermissions(RESOURCE_CODE.QUESTION_CENTER)(
                React.lazy(() => import('pages/questionCenter/detail'))
              ),
              showInMenu: false
            },
            {
              path: unit.advanced,
              name: '环节管理',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/unit/advancedUnit'))
              ),
              showInMenu: false,
              exact: true
            },
            //  高级陪练单元--配置报告
            {
              path: unit.reportSetting,
              name: '配置报告',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/unit/reportSetting'))
              ),
              showInMenu: false
            },
            {
              path: unit.assessQuestionnaireList,
              name: '互评卷',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/unit/assessQuestionnaireList'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              path: unit.assessQuestionnaireCreate,
              name: '互评卷问卷配置',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/unit/assessQuestionConfig'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              path: unit.assessQuestionnaireUpdate,
              name: '互评卷问卷配置',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/unit/assessQuestionConfig'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              path: unit.manualScoringList,
              name: '人工评分',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/unit/assessQuestionnaireList'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              path: unit.manualScoringCreate,
              name: '人工评分问卷配置',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/unit/assessQuestionConfig'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              path: unit.manualScoringUpdate,
              name: '人工评分问卷配置',
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/unit/assessQuestionConfig'))
              ),
              showInMenu: false,
              exact: true
            },
            {
              name: '新建环节',
              path: testPaper.create,
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/testPaper'))
              ),
              exact: true,
              showInMenu: false
            },
            {
              name: '编辑环节',
              path: testPaper.update,
              component: withPermissions(RESOURCE_CODE.IDENTITY_MANAGEMENT)(
                React.lazy(() => import('pages/testPaper'))
              ),
              exact: true,
              showInMenu: false
            },
            {
              path: '/systemset',
              name: '系统配置',
              component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                React.lazy(() => import('pages/systemSetting'))
              ),
              icon: <SettingOutlined />,
              code: RESOURCE_CODE.SYSTEM_SETTING,
              routes: [
                {
                  path: '/systemset/mini',
                  name: '小程序管理',
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/mini'))
                  ),
                  exact: true
                },
                {
                  path: '/systemset/pc',
                  name: 'PC管理',
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/pc'))
                  )
                },
                {
                  path: '/systemset/training',
                  name: '陪练配置',
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/training'))
                  )
                },
                {
                  path: '/systemset/hotWordConfig',
                  name: '热词配置',
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/hotWordConfig'))
                  )
                },
                {
                  path: '/systemset/prohibitWordConfig',
                  name: '违禁词配置',
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/prohibitWordConfig'))
                  )
                },
                {
                  path: '/systemset/ttsVocabsConfig',
                  name: 'TTS发音纠正词库',
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/ttsVocabsConfig'))
                  )
                },
                {
                  path: '/systemset/tag',
                  name: '标签库管理',
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/tag'))
                  )
                },
                {
                  path: '/systemset/privacyAgreement',
                  name: '用户协议',
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/privacyAgreement'))
                  )
                },
                {
                  path: '/systemset/mini/h5/new',
                  name: '新建h5',
                  showInMenu: false,
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/mini/components/MiniH5/New'))
                  )
                },
                {
                  path: '/systemset/mini/h5/:id/edit',
                  name: '编辑h5',
                  showInMenu: false,
                  component: withPermissions(RESOURCE_CODE.SYSTEM_SETTING)(
                    React.lazy(() => import('pages/systemSetting/mini/components/MiniH5/Edit'))
                  )
                },
                {
                  path: '/systemset/employeeDictionary',
                  name: '员工字典管理',
                  component: withPermissions(RESOURCE_CODE.EMPLOYEE_DICT_MANAGE)(
                    React.lazy(() => import('pages/systemSetting/employeeDictionary'))
                  )
                },
                {
                  path: '/systemset/productKnowledgeLibrary',
                  name: '产品知识库',
                  component: withPermissions(RESOURCE_CODE.PRODUCT_KNOWLEDGE)(
                    React.lazy(() => import('pages/systemSetting/productKnowledgeLibrary'))
                  )
                },
                {
                  path: '/systemset/peopleProfile',
                  name: 'AI 人设库',
                  component: withPermissions(RESOURCE_CODE.PEOPLE_PROFILE)(
                    React.lazy(() => import('pages/systemSetting/peopleProfile'))
                  )
                },
                {
                  path: aiQuestionBank.path,
                  name: 'AI 题库',
                  exact: true,
                  component: withPermissions(RESOURCE_CODE.AI_QUESTION_LIB)(
                    React.lazy(() => import('pages/aiQuestionBank'))
                  )
                },
                {
                  path: aiQuestion.path,
                  name: '题目管理',
                  showInMenu: false,
                  exact: true,
                  component: withPermissions(RESOURCE_CODE.AI_QUESTION_LIB)(
                    React.lazy(() => import('pages/aiQuestionBank/aiQuestion'))
                  )
                },
                {
                  path: aiQuestionEdit.create,
                  name: '新建题目',
                  showInMenu: false,
                  exact: true,
                  component: withPermissions(RESOURCE_CODE.AI_QUESTION_LIB)(
                    React.lazy(() => import('pages/aiQuestionBank/aiQuestionEdit/create'))
                  )
                },
                {
                  path: aiQuestionEdit.update,
                  name: '编辑题目',
                  showInMenu: false,
                  exact: true,
                  component: withPermissions(RESOURCE_CODE.AI_QUESTION_LIB)(
                    React.lazy(() => import('pages/aiQuestionBank/aiQuestionEdit/update'))
                  )
                }
              ]
            },
            {
              path: '/report/list',
              name: '数据报告',
              component: withPermissions(RESOURCE_CODE.DATA_REPORT)(
                React.lazy(() => import('pages/report'))
              ),
              exact: true,
              icon: <BarChartOutlined />,
              code: RESOURCE_CODE.DATA_REPORT
            },
            {
              path: '/report/outbound',
              name: '外呼报告',
              component: withPermissions(RESOURCE_CODE.OUTBOUND_REPORT)(
                React.lazy(() => import('pages/outboundRecords'))
              ),
              code: RESOURCE_CODE.OUTBOUND_REPORT,
              exact: true,
              icon: <CustomerServiceOutlined />
            },
            {
              path: '/logManager',
              name: '日志管理',
              component: withPermissions(RESOURCE_CODE.SYSTEM_OPERATION_LOG)(
                React.lazy(() => import('pages/logManager'))
              ),
              code: RESOURCE_CODE.SYSTEM_OPERATION_LOG,
              exact: true,
              icon: <FileSearchOutlined />
            },
            {
              path: '/password',
              name: '修改密码',
              component: React.lazy(() => import('pages/password')),
              showInMenu: false,
              exact: true,
              icon: <UserOutlined />
            },
            {
              name: '陪练单元',
              path: '/report/list/:unitId',
              showInMenu: false,
              component: withPermissions(RESOURCE_CODE.DATA_REPORT)(
                React.lazy(() => import('pages/report/unit'))
              ),
              exact: true
            },
            {
              name: '练习报告',
              path: '/report/list/:unitId/practice/:practiceId',
              showInMenu: false,
              component: withPermissions(RESOURCE_CODE.DATA_REPORT)(
                React.lazy(() => import('pages/report/practice'))
              )
            },
            {
              path: '/operate',
              name: 'H5运营页面配置',
              component: React.lazy(() => import('pages/operate')),
              showInMenu: false
            },
            {
              name: '能力模型报告',
              path: abilityModalReportConfig.path,
              code: RESOURCE_CODE.ABILITY_MODEL_REPORT,
              exact: true,
              icon: <SettingOutlined />,
              component: React.lazy(() => import('pages/abilityModalReportConfig'))
            },
            {
              name: '能力模型报告编辑',
              path: abilityModalReportConfig.editPath,
              code: RESOURCE_CODE.ABILITY_MODEL_REPORT,
              exact: true,
              showInMenu: false,
              component: React.lazy(
                () => import('pages/abilityModalReportConfig/abilityModalConfigEdit')
              )
            },
            {
              path: noAuthConfig.path,
              name: '',
              component: React.lazy(() => import('pages/noAuth')),
              showInMenu: false
            },
            {
              path: '/',
              // redirect: '/recordlist/student',
              showInMenu: false,
              component: React.lazy(() => import('pages'))
            },
            {
              component: React.lazy(() => import('pages/exception/notFound'))
            }
          ]
        }
      ]
    }
  ];
};

function addLazyComponent(routes: IRoute[]) {
  routes.forEach(route => {
    if (route.component) {
      route.component = React.lazy(route.component);
    }
    if (route.routes) {
      addLazyComponent(route.routes);
    }
  });
}

// addLazyComponent(routes);
export { getRoutes };
export default routes;
